<template>
  <div />
</template>

<script>
import AbstractPage from 'chimera/all/components/page/AbstractPage'

export default {
  extends: AbstractPage,

  layout: 'content',

  /**
   * @returns {object}
   */
  data() {
    return {
      headTitle: undefined,
      headDescription: undefined,
    }
  },

  /**
   */
  created() {
    this.headTitle = this.$t('privacyPolicy.title')
    this.headDescription = this.$t('privacyPolicy.headDescription')
  },
}
</script>
